import { Input } from '@arco-design/web-react'
import { SENSITIVE_PLACEHOLDER } from './optionKeys'

interface Props {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  rows?: number
  /** 非敏感多行字段（如公钥证书）仍显示留空提示 */
  showConfiguredHint?: boolean
}

/** 多行敏感 option：GET 不返回值，留空保存时不覆盖后端已有配置 */
export default function SensitiveTextArea({
  value,
  onChange,
  placeholder,
  rows = 3,
  showConfiguredHint = true,
}: Props) {
  const hint =
    placeholder ??
    (showConfiguredHint && !value.trim() ? SENSITIVE_PLACEHOLDER : undefined)

  return (
    <Input.TextArea
      value={value}
      onChange={onChange}
      placeholder={hint}
      autoSize={{ minRows: rows, maxRows: rows * 4 }}
      autoComplete="off"
      style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: 12 }}
    />
  )
}
